/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonBalanceBase,
  PersonBalanceBaseOptional,
  PersonBalanceBaseMetaI,
  PersonBalanceBaseTrackedI,
} from "./person-balance-base";
import {
  PersonBalanceBaseTracked,
  PersonBalanceBaseMeta,
} from "./person-balance-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonNameInfoAndRef,
  PersonNameInfoAndRefOptional,
  PersonNameInfoAndRefMetaI,
  PersonNameInfoAndRefTrackedI,
} from "./person-name-info-and-ref";
import {
  PersonNameInfoAndRefTracked,
  PersonNameInfoAndRefMeta,
} from "./person-name-info-and-ref";

/**
 *
 * @export
 * @interface PersonBalanceDTO
 */
export interface PersonBalanceDTOOptional extends PersonBalanceBaseOptional {
  /**
   *
   * @type {number}
   * @memberof PersonBalanceDTO
   */
  assignId?: number;
  /**
   *
   * @type {boolean}
   * @memberof PersonBalanceDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonBalanceDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof PersonBalanceDTO
   */
  personId?: PersonNameInfoAndRefOptional;
}

export interface PersonBalanceDTO
  extends PersonBalanceDTOOptional, PersonBalanceBase {
  /**
   *
   * @type {number}
   * @memberof PersonBalanceDTO
   */
  assignId: number;
  /**
   *
   * @type {boolean}
   * @memberof PersonBalanceDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonBalanceDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof PersonBalanceDTO
   */
  personId: PersonNameInfoAndRef;
}

export interface PersonBalanceDTOTrackedI extends PersonBalanceBaseOptional {
  /**
   *
   * @type {number}
   * @memberof PersonBalanceDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonBalanceDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonBalanceDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof PersonBalanceDTO
   */
  personId?: PersonNameInfoAndRefTrackedI;
  personIdIsSet: boolean;
}

transformDatesMap.set("PersonBalanceDTO", function (model: PersonBalanceDTO) {
  const transformDatespersonId = transformDatesMap.get("PersonNameInfoAndRef");
  if (transformDatespersonId && model.personId) {
    transformDatespersonId(model.personId);
  }
});

export type PersonBalanceDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonNameInfoAndRefMetaI>;
}>;

export var PersonBalanceDTOMeta: PersonBalanceDTOMetaI =
  {} as PersonBalanceDTOMetaI;
PersonBalanceDTOMeta = typeMeta("PersonBalanceDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  personId: propertyMeta(
    "personId",
    false,
    true,
    false,
    PersonNameInfoAndRefMeta,
  ),
});

const metaI = PersonBalanceDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonBalanceBaseMeta]);
  metaI.assignId.inheritedFrom = PersonBalanceBaseMeta.assignId;
  metaI.isDeleted.inheritedFrom = PersonBalanceBaseMeta.isDeleted;
  metaI.isNew.inheritedFrom = PersonBalanceBaseMeta.isNew;
  metaI.personId.inheritedFrom = PersonBalanceBaseMeta.personId;
});

export class PersonBalanceDTOTracked
  extends PersonBalanceBaseTracked
  implements PersonBalanceDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  personId__I?: PersonNameInfoAndRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonNameInfoAndRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  constructor(config?: PersonBalanceDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personId?.setIds();
  }
  assignFrom(
    config: PersonBalanceDTOOptional,
    options?: AssignOptions,
  ): PersonBalanceDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonNameInfoAndRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonBalanceDTOTrackedI {
    const cloned = {} as PersonBalanceDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonBalanceDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonBalanceDTOMeta.assignId,
      PersonBalanceDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonBalanceDTOMeta.isDeleted,
      PersonBalanceDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonBalanceDTOMeta.isNew,
      PersonBalanceDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonBalanceDTOMeta.personId,
      PersonBalanceDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
